<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="onCancel()" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('permissionStages.addUserDialog.title') }}</h2>

	<form [formGroup]="inviteUserForm" (ngSubmit)="onSubmit()">
		<mat-dialog-content>
			<p class="mb-4 whitespace-pre-wrap">{{ t('permissionStages.addUserDialog.description') }}</p>
			<p class="mb-4 whitespace-pre-wrap font-bold">{{ t('permissionStages.addUserDialog.deleteWarning') }}</p>

			<mat-form-field class="w-full">
				<mat-label>{{ t('permissionStages.addUserDialog.assignRole') }}</mat-label>
				<mat-select formControlName="role">
					@for (role of data.availableRoles; track role) {
						<mat-option [value]="role">{{ t('groupRoleType.' + role) }}</mat-option>
					}
				</mat-select>
				<mat-icon
					matSuffix
					[svgIcon]="icons.get('help')"
					[matTooltip]="t('permissionStages.addUserDialog.groupRoleTypeDescription.' + role?.value)"
					matTooltipClass="multi-line-tooltip"></mat-icon>
			</mat-form-field>

			<mat-form-field class="w-full">
				<mat-label>{{ t('user.email') }}</mat-label>
				<input matInput formControlName="email" cdkFocusInitial />
				@if (email?.hasError('required')) {
					<mat-error>{{ t('common.requiredField') }}</mat-error>
				}
				@if (email?.hasError('email')) {
					<mat-error>{{ t('permissionStages.addUserDialog.enterValidEmail') }}</mat-error>
				}
			</mat-form-field>

			<mat-form-field class="w-full">
				<mat-label>{{ t('user.firstname') }}</mat-label>
				<input matInput formControlName="firstName" />
				@if (firstName?.hasError('required')) {
					<mat-error>{{ t('common.requiredField') }}</mat-error>
				}
			</mat-form-field>

			<mat-form-field class="w-full">
				<mat-label>{{ t('user.lastname') }}</mat-label>
				<input matInput formControlName="lastName" />
				@if (lastName?.hasError('required')) {
					<mat-error>{{ t('common.requiredField') }}</mat-error>
				}
			</mat-form-field>
		</mat-dialog-content>

		<mat-dialog-actions align="end">
			<button mat-button type="button" (click)="onCancel()">{{ t('commonActions.cancel') }}</button>
			<button mat-flat-button color="primary" type="submit" [disabled]="!inviteUserForm.valid">
				{{ t('permissionStages.addUserDialog.inviteUser') }}
			</button>
		</mat-dialog-actions>
	</form>
</div>
